import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Price from '../Price';
import Result from '../Result';
import formatLevelStakes from './utils/formatLevelStakes';
import HorseLink from '../common/HorseLink';

const NapsTableRow = ({
    order,
    time,
    crs,
    tipster,
    levelStakes,
    horseId,
    horseName,
    outcome,
    oddsDesc,
    date,
    courseName,
    diffusionTime,
    raceId,
}) => (
    <div
        className="tn-napsTable__row ui-table__row"
        style={{ order }}
    >
        <div className="tn-napsTable__main">
            <div
                className={classNames(
                    'ui-table__cell',
                    'tn-napsTable__cell',
                    'tn-napsTable__naps',
                )}
            >
                <HorseLink horseId={horseId} horseName={horseName} />
            </div>
            <div
                className={classNames(
                    'ui-table__cell',
                    'tn-napsTable__cell',
                    'tn-napsTable__time',
                )}
            >{ time }</div>
            <div
                className={classNames(
                    'ui-table__cell',
                    'tn-napsTable__cell',
                    'tn-napsTable__crs',
                )}
            >{ crs }</div>
            <div
                className={classNames(
                    'ui-table__cell',
                    'tn-napsTable__cell',
                    'tn-napsTable__tipster',
                )}
            >{ tipster }</div>
            <div
                className={classNames(
                    'ui-table__cell',
                    'tn-napsTable__cell',
                    'tn-napsTable__levelStakes',
                )}
            >{ formatLevelStakes(levelStakes) }</div>
        </div>
        <div
            className={classNames(
                'ui-table__cell',
                'tn-napsTable__cell',
                'tn-napsTable__odds',
            )}
        >
            { ((!outcome && !oddsDesc) || outcome === '0') ?
                <Price
                    horseName={horseName}
                    raceDate={date}
                    courseName={courseName}
                    raceTime={diffusionTime}
                    raceId={raceId}
                    raceDateTime={`${date}T${diffusionTime}:00+01:00`}
                /> :
                <Result
                    outcome={outcome}
                    oddsDesc={oddsDesc}
                />
        }
        </div>
    </div>
);

NapsTableRow.defaultProps = {
    order: 999,
    time: '',
    crs: '',
    tipster: '',
    levelStakes: null,
    horseId: null,
    horseName: '',
    date: '',
    courseName: '',
    diffusionTime: '',
    raceId: null,
    outcome: '',
    oddsDesc: '',
};

NapsTableRow.propTypes = {
    order: PropTypes.number,
    time: PropTypes.string,
    crs: PropTypes.string,
    tipster: PropTypes.string,
    levelStakes: PropTypes.string,
    horseId: PropTypes.number,
    horseName: PropTypes.string,
    date: PropTypes.string,
    courseName: PropTypes.string,
    diffusionTime: PropTypes.string,
    raceId: PropTypes.number,
    outcome: PropTypes.string,
    oddsDesc: PropTypes.string,
};

export default NapsTableRow;




// WEBPACK FOOTER //
// ./src/js/napsTable/NapsTableRow.js